<script>
import Template from '{Template}/Admin/Pages/Admin/Liquidity/Index.template'
import AppLayout from '@/Layouts/AdminLayout'
import Welcome from '@/Jetstream/Welcome'
import NavButtonLink from "@/Jetstream/NavButtonLink";
import NavButton from "@/Jetstream/NavButton";
import NavButtonActive from "@/Jetstream/NavButtonActive";
import Pagination from '@/Jetstream/Pagination'
import NavLink from "@/Jetstream/NavLink";
import Badge from "@/Jetstream/Badge";

export default Template({
    components: {
        Badge,
        NavLink,
        NavButtonLink,
        AppLayout,
        Welcome,
        Pagination,
        NavButton,
        NavButtonActive
    },
    props: {
        markets: Object,
        liquidity: Array,
    },
    data() {
        return {
            sending: false,
            activeMarkets: this.liquidity,
        }
    },
    methods: {
        runLiquidity(market) {

            if(this.sending) return;

            this.sending = market.id;

            axios.post(route('admin.liquidity.run'), {
                market: market.name,
            }).then((response) => {
                this.$toast.open(response.data.status);
                this.activeMarkets = response.data.markets;
                this.sending = false;
            }).catch(error => {
                this.sending = false;
            });
        },
        stopLiquidity(market) {
            axios.post(route('admin.liquidity.stop'), {
                market: market.name,
            }).then((response) => {
                this.$toast.open(response.data.status);
                this.activeMarkets = response.data.markets;
            }).catch(error => {

            });
        }
    }
})
</script>
